goog.provide("shadow.js.shim.module$dayjs$locale$fi");
goog.provide("module$shadow_js_shim_module$dayjs$locale$fi");
shadow.js.shim.module$dayjs$locale$fi = shadow.js.nativeProvides["dayjs/locale/fi"] = require("dayjs/locale/fi");
module$shadow_js_shim_module$dayjs$locale$fi.default = shadow.js.shim.module$dayjs$locale$fi;
